module.exports = __webpack_public_path__ + "img/81.c46e6771.jpg";